import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import registerServiceWorker from "./registerServiceWorker";
import configureStore from "./redux/store/";
import App from "./containers/app/App";

// style
// import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import './assets/vendors/base/mdb/css/mdb.css';
import './assets/vendors/base/bootstrap-rtl.min.css';
import './assets/vendors/base/fonts/vazir/vazir.css';
import './assets/vendors/base/fonts/flaticon/Flaticon.css';
import './assets/vendors/base/fonts/line-awesome/line-awesome.css';
import 'react-toastify/dist/ReactToastify.min.css';
import './assets/custom/front/style.bundle.css';

// if need jquery
// import jquery from "jquery";
// window.$ = window.jQuery = jquery;
// window.Popper = require("popper.js");
// require("bootstrap/dist/js/bootstrap");



const store = configureStore();
// CheckUserLoginFromApi(store);

ReactDOM.render(
    <Provider store={store}>
        <App store={store}/>
    </Provider>,
    document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js